import { useTranslation } from "react-i18next";

const UseChange = ({ data }) => {
  let { t } = useTranslation();
  return t(data);
};
export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  passwordMessage: "Password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  confirmPasswordMessage: "Confirm password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  newPasswordMessage: "New password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  xcharacters: /^[a-zA-Z_ ]*$/,
  charactersMessage: "Only alphabets are allowed.",
  numbers: /^[0-9]*$/,
  removeWhitespace: /^[a-zA-Z0-9][a-zA-Z0-9 \^\\\-!@#$%&*ËÇeç()_~.+,/'"]+$/g,
};

export const staticHTMLTags = {
  searchItemSVGImage: `<svg aria-hidden='true' className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'> <pathstrokeLinecap='round'strokeLinejoin='round'strokeWidth='2'd='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'/></svg>`,
};

export const statusOptions = [
  { value: "active", label: "O_ACTIVE" },
  { value: "inactive", label: "O_INACTIVE" },
];

export const subscriptionOptions = [
  { value: "active", label: "SUBSCRIBED" },
  { value: "inactive", label: "UNSUBSCRIBED" },
];
export const employeeOptions = [
  { value: "accepted", label: "ACCEPTED" },
  { value: "rejected", label: "REJECTED" },
  { value: "promoted", label: "PROMOTED" },
  { value: "discharged", label: "DISCHARGED" },
];
export const leaveStatusOptions = [
  { value: 'on_leave', label: 'ON_LEAVE' },
  { value: 'working', label: 'Available' }
];
export const employmentStatusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'paid_leave', label: 'Paid Leave' },
  { value: 'unpaid_leave', label: 'Unpaid Leave' },
  { value: 'terminated', label: 'Terminated' },
  { value: 'not_on_payroll', label: 'Not on Payroll' },
  { value: 'deceased', label: 'Deceased' }
];
export const formStatusOptions = [
  { value: 'pending', label: 'Pending' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'rejected', label: 'Rejected' },
  { value: "promoted", label: "PROMOTED" },
  { value: "discharged", label: "DISCHARGED" },
]

export const categoryOptions = [
  { value: "accepted", label: "ACCEPTED" },
  { value: "rejected", label: "REJECTED" },
];

export const offerLetterOptions = [
  { value: "pending", label: "PENDING" },
  { value: "sent", label: "SENT" },
];

export const salaryOptions = [
  { value: "paid", label: "PAID" },
  { value: "pending", label: "PENDING" },
];
export const durationOptions = [
  { value: "Weekly", label: "WEEKLY" },
  { value: "Fortnight", label: "FORTNIGHT" },
  { value: "Monthly", label: "MONTHLY" },
];
export const supportOptions = [
  { value: "pending", label: "PENDING" },
  { value: "replied", label: "REPLIED" },
];

export const supportSorting = [
  { sortBy: "email", displayText: <>{<UseChange data="O_EMAIL_ID" />}</> },
  {
    sortBy: "createdAt",
    displayText: <>{<UseChange data="CREATED_DATE" />}</>,
  },
  {
    sortBy: "adminReplyDate",
    displayText: <>{<UseChange data="REPLY_DATE" />}</>,
  },
];
export const subAdminSorting = [
  { sortBy: "email", displayText: <>{<UseChange data="O_EMAIL_ID" />}</> },
  {
    sortBy: "createdAt",
    displayText: <>{<UseChange data="CREATED_DATE" />}</>,
  },
];

export const sortingOptionsOfferTable = [
  {
    sortBy: "Employee.email",
    displayText: <>{<UseChange data="EMAIL_ID" />}</>,
  },
  {
    sortBy: "offerSentDate",
    displayText: <>{<UseChange data="OFFER_SENT_DATE" />}</>,
  },
];
export const sortingOptionsSubCategory = [
  {
    sortBy: "createdAt",
    displayText: <>{<UseChange data="CREATED_DATE" />}</>,
  },
  {
    sortBy: "updatedAt",
    displayText: <>{<UseChange data="UPDATED_DATE" />}</>,
  },
];
